(function(){
  var COMPANY_ID = 'QPR54y';
  var WA_NUMBER = '56933353225';
  var SHOW_VIDEO = false;
  var VIDEO_URL = '';

  var root = document.getElementById('ndf-dl');
  if (!root) return;

  var QS = [
    { eje:'decisiones fuera de lo habitual', q:'cuando tu equipo tiene que tomar una decisión fuera de lo habitual, ¿qué ocurre?', o:[
      'la persona responsable sabe qué hacer y puede decidir sin consultarme.',
      'depende del caso; algunas decisiones avanzan y otras llegan hasta mí.',
      'la mayoría de las veces prefieren preguntarme antes de decidir.']},
    { eje:'criterios', q:'¿tu equipo tiene criterios claros para saber cómo tomar esas decisiones?', o:[
      'sí. existen reglas, números, rangos o criterios claros para decidir.',
      'en algunas áreas sí, pero todavía existen varias zonas grises.',
      'no demasiado. muchos de esos criterios todavía están principalmente en mi cabeza.']},
    { eje:'límites de autoridad', q:'¿está claro hasta dónde puede decidir cada persona sin pedir tu aprobación?', o:[
      'sí. saben qué pueden decidir y cuándo necesitan escalar algo.',
      'más o menos. existen límites, pero no siempre están claros.',
      'no. ante la duda, la decisión normalmente termina llegando hasta mí.']}
  ];
  var L = ['a','b','c'];
  var CIERRE = 'delegar no es solamente entregar tareas. es lograr que determinadas decisiones puedan avanzar sin volver siempre a tu escritorio.';
  var RES = {
    a:{ label:'autonomía clara', nivel:'verde', color:'#7ED957', ink:'#022332', pos:83.3,
        p1:'tu equipo parece contar con criterios y límites de autoridad que le permiten resolver una parte importante de las decisiones sin depender constantemente de ti.',
        p2:'el siguiente desafío puede ser detectar qué otras decisiones todavía podrían transferirse.' },
    b:{ label:'criterios por definir', nivel:'amarillo', color:'#E8B62C', ink:'#022332', pos:50,
        p1:'ya existe cierta autonomía, pero todavía hay zonas grises.',
        p2:'puede haber una oportunidad en definir mejor qué puede decidir cada persona, con qué criterio y cuándo debe escalar una decisión.' },
    c:{ label:'decisiones concentradas', nivel:'rojo', color:'#e7392f', ink:'#fff', pos:16.7,
        p1:'muchas decisiones todavía pueden estar dependiendo directamente de tu criterio o aprobación.',
        p2:'el punto de partida puede estar en transformar aquello que hoy está principalmente en tu cabeza en reglas, rangos, criterios o niveles de autoridad claros.' }
  };

  var state = { screen:'hero', idx:0, answers:[null,null,null], sel:null, name:'', email:'' };
  var sent = false, poll = null, first = true;

  function esc(s){ return String(s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];}); }
  function validEmail(e){ return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(e).trim()); }
  function setEnabled(btn, on){
    if (!btn) return;
    btn.disabled = !on;
    btn.style.opacity = on ? '1' : '.35';
    btn.style.cursor = on ? 'pointer' : 'not-allowed';
    btn.setAttribute('aria-disabled', on ? 'false' : 'true');
  }

  function compute(){
    var c = {a:0,b:0,c:0};
    state.answers.forEach(function(x){ if (x) c[x]++; });
    var key = 'b', empate = false;
    if (c.a >= 2) key = 'a'; else if (c.b >= 2) key = 'b'; else if (c.c >= 2) key = 'c'; else empate = true;
    return { key:key, counts:c, empate:empate };
  }

  function waLink(label){
    return 'https://wa.me/' + WA_NUMBER + '?text=' + encodeURIComponent('hola, hice el test de delegar de ndf growth y mi resultado fue: ' + label + '. quiero agendar mi diagnóstico');
  }

  function sendKlaviyo(r){
    if (sent) return; sent = true;
    var R = RES[r.key];
    var body = { data:{ type:'event', attributes:{
      properties:{
        resultado:r.key, resultado_label:R.label, nivel:R.nivel,
        conteo_a:r.counts.a, conteo_b:r.counts.b, conteo_c:r.counts.c, empate:r.empate,
        resultado_p1:R.p1, resultado_p2:R.p2, cierre:CIERRE,
        respuestas:{ p1:state.answers[0], p2:state.answers[1], p3:state.answers[2] }
      },
      metric:{ data:{ type:'metric', attributes:{ name:'Test delegar completado' } } },
      profile:{ data:{ type:'profile', attributes:{ email:state.email.trim(), first_name:state.name.trim() } } }
    }}};
    try {
      fetch('https://a.klaviyo.com/client/events?company_id=' + encodeURIComponent(COMPANY_ID), {
        method:'POST',
        headers:{ 'Content-Type':'application/vnd.api+json', 'Accept':'application/vnd.api+json', 'revision':'2024-10-15' },
        body:JSON.stringify(body)
      }).catch(function(){});
    } catch(e){}
  }

  /* ---------- pantallas ---------- */
  function rHero(){
    return '<section class="s pet hero" data-screen-label="01 hero"><div class="wrap">' +
      '<div style="display:flex;flex-direction:column;gap:28px;align-items:flex-start">' +
        '<div class="kick">ndf growth · delegar decisiones</div>' +
        '<h1 class="h1h">3 preguntas para detectar qué decisiones podrías sacar de tu escritorio</h1>' +
        '<div class="sub"><p>tener más personas en el equipo no necesariamente significa que tu ecommerce dependa menos de ti.</p><p>puedes delegar tareas y, aun así, seguir concentrando las decisiones.</p></div>' +
        '<div style="display:flex;flex-direction:column;gap:14px;align-items:flex-start;width:100%;margin-top:8px">' +
          '<button type="button" class="btn btn-l" data-action="start">empezar</button>' +
          '<div class="micro-p">3 preguntas · 1 minuto</div>' +
        '</div>' +
      '</div>' +
      '<hr class="div">' +
      '<div style="display:flex;flex-direction:column;gap:24px">' +
        '<div class="kick">cómo funciona</div>' +
        '<div class="how">' +
          '<div><div class="how-n" style="color:#7ED957">01</div><p class="how-t">piensas en las decisiones que llegan hasta ti durante una semana.</p></div>' +
          '<div><div class="how-n" style="color:#E8762C">02</div><p class="how-t">respondes 3 preguntas sobre cómo se toman hoy.</p></div>' +
          '<div><div class="how-n" style="color:#4884a3">03</div><p class="how-t">te mostramos qué tan concentradas están en ti.</p></div>' +
        '</div>' +
      '</div>' +
    '</div></section>';
  }

  function rAviso(){
    return '<section class="s pet center aviso" data-screen-label="02 aviso"><div class="wrap">' +
      '<div class="kick">antes de empezar</div>' +
      '<p class="av-p">piensa en las decisiones que normalmente llegan hasta ti durante una semana: campañas, presupuesto, promociones, stock, proveedores, descuentos, clientes, equipo, etc.</p>' +
      '<p class="av-b">ahora responde estas 3 preguntas pensando en cómo funciona tu ecommerce hoy.</p>' +
      '<button type="button" class="btn btn-l" data-action="go" style="margin-top:8px">entendido, vamos</button>' +
    '</div></section>';
  }

  function rQ(){
    var i = state.idx, Q = QS[i], sel = state.sel;
    var opts = Q.o.map(function(t,k){
      var on = sel === L[k];
      return '<button type="button" class="opt' + (on?' on':'') + '" role="radio" aria-checked="' + on + '" tabindex="' + ((on || (!sel && k===0)) ? '0' : '-1') + '" data-action="pick" data-val="' + L[k] + '">' +
        '<span class="let" aria-hidden="true">' + L[k] + '</span><span class="opt-t">' + esc(t) + '</span></button>';
    }).join('');
    return '<section class="s crm q" data-screen-label="0' + (i+3) + ' pregunta ' + (i+1) + '"><div class="wrap">' +
      '<div class="q-top">' +
        '<div class="q-meta kick"><span>pregunta ' + (i+1) + ' de 3</span><span class="eje">' + esc(Q.eje) + '</span></div>' +
        '<div class="bar" role="progressbar" aria-valuemin="1" aria-valuemax="3" aria-valuenow="' + (i+1) + '"><i style="width:' + ((i+1)/3*100) + '%"></i></div>' +
      '</div>' +
      '<h2 class="h2q" id="ndf-dl-q">' + esc(Q.q) + '</h2>' +
      '<div class="opts" role="radiogroup" aria-labelledby="ndf-dl-q">' + opts + '</div>' +
      '<div class="row">' +
        '<button type="button" class="btn btn-d" data-action="next" data-role="next">siguiente</button>' +
        (i > 0 ? '<button type="button" class="lnk" data-action="back">volver</button>' : '') +
      '</div>' +
    '</div></section>';
  }

  function rGate(){
    return '<section class="s crm center gate" data-screen-label="06 gate"><div class="wrap">' +
      '<div class="kick">último paso</div>' +
      '<h2 class="h2g">tu resultado está listo.</h2>' +
      '<p class="g-p">te lo mostraremos en pantalla y también te llegará a tu correo.</p>' +
      '<form class="fields" data-role="form" novalidate>' +
        '<label style="position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0)" for="ndf-dl-name">tu nombre</label>' +
        '<input class="inp" id="ndf-dl-name" name="name" type="text" autocomplete="given-name" placeholder="tu nombre" value="' + esc(state.name) + '">' +
        '<label style="position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0)" for="ndf-dl-email">tu correo</label>' +
        '<input class="inp" id="ndf-dl-email" name="email" type="email" inputmode="email" autocomplete="email" placeholder="tu correo" value="' + esc(state.email) + '">' +
        '<button type="submit" class="btn btn-d full" data-action="submit" data-role="submit" style="margin-top:4px">ver mi resultado</button>' +
      '</form>' +
      '<p class="micro-c">nada de spam. te escribimos cuando tenemos algo que sirve.</p>' +
    '</div></section>';
  }

  function rRes(){
    var r = compute(), R = RES[r.key];
    var pin = '<svg class="pin" style="left:' + R.pos + '%" viewBox="0 0 24 24" aria-hidden="true"><path fill="#022332" d="M12 1.5c-4.4 0-8 3.5-8 7.9 0 5.6 6.9 12.3 7.2 12.6.4.4 1.1.4 1.5 0 .3-.3 7.3-7 7.3-12.6 0-4.4-3.6-7.9-8-7.9z"/><circle cx="12" cy="9.4" r="3.2" fill="#FBF8F3"/></svg>';
    var video = SHOW_VIDEO ? '<div class="vid" data-role="vid"><button type="button" class="play" data-action="play" aria-label="reproducir video"><svg width="26" height="26" viewBox="0 0 24 24" aria-hidden="true"><path fill="#022332" d="M8 5.5v13l11-6.5z"/></svg></button></div>' : '';
    return '<section class="s crm res" data-screen-label="07 resultado"><div class="wrap">' +
      '<div class="r-head">' +
        '<div class="kick">tu resultado</div>' +
        '<span class="pill" style="background:' + R.color + ';color:' + R.ink + '">mayoría ' + r.key + '</span>' +
        '<h1 class="h1r">' + esc(R.label) + '</h1>' +
      '</div>' +
      '<div class="meter" role="img" aria-label="medidor: ' + esc(R.label) + '">' + pin +
        '<div class="track"><span style="background:#e7392f"></span><span style="background:#E8B62C"></span><span style="background:#7ED957"></span></div>' +
        '<div class="m-lab"><span>decisiones concentradas</span><span>criterios por definir</span><span>autonomía clara</span></div>' +
      '</div>' +
      video +
      '<div class="mean">' +
        '<div class="kick">qué significa</div>' +
        '<p class="r-p">' + esc(R.p1) + '</p>' +
        '<p class="r-p">' + esc(R.p2) + '</p>' +
        '<p class="close">' + esc(CIERRE) + '</p>' +
      '</div>' +
      '<div class="pet cta">' +
        '<h2 class="cta-t">¿quieres revisar qué está limitando hoy el crecimiento de tu ecommerce?</h2>' +
        '<p class="cta-p">en ndf growth trabajamos durante 60 días sobre la empresa que ya tienes para identificar entre 3 y 5 palancas clave que merecen atención y reducir dependencias que pueden estar frenando su siguiente etapa.</p>' +
        '<p class="cta-p">si tu ecommerce está vendiendo, genera resultados y quieres entender qué deberías destrabar primero, agenda un diagnóstico con nuestro equipo para revisar tu caso y evaluar si ndf growth tiene sentido para tu empresa.</p>' +
        '<a class="btn btn-l" href="' + esc(waLink(R.label)) + '" target="_blank" rel="noopener">quiero agendar mi diagnóstico ndf growth</a>' +
      '</div>' +
      '<button type="button" class="lnk restart" data-action="restart">volver a empezar</button>' +
    '</div></section>';
  }

  /* ---------- render ---------- */
  function scrollTop(){
    if (first) { first = false; return; }
    var m = parseFloat(getComputedStyle(root).scrollMarginTop) || 0;
    var y = root.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop) - m;
    window.scrollTo(0, Math.max(0, y));
  }

  function stopPoll(){ if (poll) { clearInterval(poll); poll = null; } }

  function render(){
    stopPoll();
    var s = state.screen;
    root.innerHTML = s==='hero' ? rHero() : s==='aviso' ? rAviso() : s==='q' ? rQ() : s==='gate' ? rGate() : rRes();
    scrollTop();
    if (s === 'q') syncQ();
    if (s === 'gate') { syncGate(); poll = setInterval(syncGate, 350); }
    if (s === 'res') sendKlaviyo(compute());
  }

  function syncQ(){ setEnabled(root.querySelector('[data-role="next"]'), !!state.sel); }

  function syncGate(){
    var n = root.querySelector('#ndf-dl-name'), e = root.querySelector('#ndf-dl-email');
    if (!n || !e) return;
    state.name = n.value; state.email = e.value;
    setEnabled(root.querySelector('[data-role="submit"]'), state.name.trim() !== '' && validEmail(state.email));
  }

  function applySel(){
    var btns = root.querySelectorAll('.opt');
    for (var k = 0; k < btns.length; k++) {
      var on = btns[k].getAttribute('data-val') === state.sel;
      btns[k].classList.toggle('on', on);
      btns[k].setAttribute('aria-checked', on ? 'true' : 'false');
      btns[k].tabIndex = on ? 0 : -1;
    }
    syncQ();
  }

  function goQ(i){ state.idx = i; state.sel = state.answers[i]; state.screen = 'q'; render(); }

  function submitGate(){
    syncGate();
    if (state.name.trim() === '' || !validEmail(state.email)) return;
    state.screen = 'res'; render();
  }

  var actions = {
    start:function(){ state.screen = 'aviso'; render(); },
    go:function(){ goQ(0); },
    pick:function(el){ state.sel = el.getAttribute('data-val'); applySel(); },
    next:function(){
      if (!state.sel) return;
      state.answers[state.idx] = state.sel;
      if (state.idx < 2) goQ(state.idx + 1); else { state.screen = 'gate'; render(); }
    },
    back:function(){ if (state.sel) state.answers[state.idx] = state.sel; if (state.idx > 0) goQ(state.idx - 1); },
    submit:function(el, ev){ ev.preventDefault(); submitGate(); },
    play:function(){
      var box = root.querySelector('[data-role="vid"]');
      if (!box || !VIDEO_URL) return;
      if (/youtube|youtu\.be|vimeo|loom/.test(VIDEO_URL)) box.innerHTML = '<iframe src="' + esc(VIDEO_URL) + '" allow="autoplay; fullscreen" allowfullscreen></iframe>';
      else box.innerHTML = '<video src="' + esc(VIDEO_URL) + '" autoplay playsinline controls></video>';
    },
    restart:function(){
      state = { screen:'hero', idx:0, answers:[null,null,null], sel:null, name:'', email:'' };
      sent = false; render();
    }
  };

  document.addEventListener('click', function(ev){
    var el = ev.target && ev.target.closest ? ev.target.closest('[data-action]') : null;
    if (!el || !root.contains(el)) return;
    if (el.disabled) { ev.preventDefault(); return; }
    var fn = actions[el.getAttribute('data-action')];
    if (fn) fn(el, ev);
  });

  root.addEventListener('submit', function(ev){ ev.preventDefault(); submitGate(); });
  root.addEventListener('input', function(ev){ if (ev.target.classList && ev.target.classList.contains('inp')) syncGate(); });
  root.addEventListener('change', function(ev){ if (ev.target.classList && ev.target.classList.contains('inp')) syncGate(); });

  root.addEventListener('keydown', function(ev){
    if (state.screen !== 'q') return;
    var t = ev.target;
    if (!t.classList || !t.classList.contains('opt')) return;
    var k = ev.key;
    if (k !== 'ArrowDown' && k !== 'ArrowUp' && k !== 'ArrowRight' && k !== 'ArrowLeft') return;
    ev.preventDefault();
    var btns = Array.prototype.slice.call(root.querySelectorAll('.opt'));
    var i = btns.indexOf(t), d = (k === 'ArrowDown' || k === 'ArrowRight') ? 1 : -1;
    var nx = btns[(i + d + btns.length) % btns.length];
    state.sel = nx.getAttribute('data-val'); applySel(); nx.focus();
  });

  render();
})();